module.exports = __webpack_public_path__ + "static/media/tynax-anim.2ad15496.gif";